import { buildLobbyPath, navigateTo } from "../../../router";
import { resolveHorrorRaceRouteMode } from "../route-mode";
import { Button } from "./ui/button";
import { Card } from "./ui/card";

interface GameOverScreenProps {
  readonly garnets: Readonly<Record<string, number>>;
  readonly playerNames: Readonly<Record<string, string>>;
  readonly winnerColor?: string;
}

export function GameOverScreen({
  garnets,
  playerNames,
  winnerColor,
}: GameOverScreenProps) {
  const sorted = Object.entries(garnets).sort((a, b) => b[1] - a[1]);
  const winnerHue = winnerColor ?? "var(--cn-horror-finished-flash)";

  return (
    <div
      data-testid="game-over-overlay"
      data-game="horror-race"
      className="flex min-h-screen flex-col items-center justify-center p-6"
      style={{ backgroundColor: "var(--cn-horror-bg)" }}
    >
      <Card
        className="w-full max-w-[500px] p-8 text-center shadow-lg"
        style={{
          backgroundColor: "var(--cn-horror-card-bg)",
          border: `2px solid ${winnerHue}`,
          boxShadow: `0 0 32px ${winnerHue}`,
        }}
      >
        <h1 className="mb-6 font-bold text-3xl" style={{ color: winnerHue }}>
          게임 종료
        </h1>

        {sorted.map(([playerId, total], index) => (
          <div
            key={playerId}
            data-testid={
              index === 0 ? "winner-display" : `player-rank-${index + 1}`
            }
            data-player-id={playerId}
            className="mb-2 flex items-center justify-between rounded-lg px-4 py-3"
            style={{
              backgroundColor:
                index === 0
                  ? "var(--cn-horror-track)"
                  : "var(--cn-horror-surface)",
              border: `${index === 0 ? 2 : 1}px solid ${
                index === 0 ? winnerHue : "var(--cn-horror-surface-border)"
              }`,
            }}
          >
            <span
              className="text-base"
              style={{ color: "var(--cn-horror-text)" }}
            >
              {index === 0 ? "🏆 " : ""}
              {playerNames[playerId] ?? playerId}
            </span>
            <span
              className="font-bold text-lg"
              style={{ color: "var(--cn-horror-finished-flash)" }}
            >
              {total} 가넷
            </span>
          </div>
        ))}

        <Button
          variant="primary"
          size="lg"
          className="mt-6 w-full"
          data-testid="game-over-new-game-btn"
          onClick={() =>
            navigateTo(
              buildLobbyPath("horror-race", resolveHorrorRaceRouteMode()),
            )
          }
        >
          로비로 돌아가기
        </Button>
      </Card>
    </div>
  );
}
